import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getEmails = async (customerId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/customers/${customerId}/emails`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data.map((email) => ({
    ...email,
    attachments: email.attachments ? JSON.parse(email.attachments) : [],
  }));
};

export const addEmail = async (customerId, email) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/customers/${customerId}/emails`,
    {
      ...email,
      attachments: JSON.stringify(email.attachments || []),
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateEmail = async (id, email) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(
    `${API_URL}/emails/${id}`,
    {
      ...email,
      attachments: JSON.stringify(email.attachments || []),
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const deleteEmail = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${API_URL}/emails/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getAllEmails = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/emails`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.map((email) => ({
    ...email,
    attachments: email.attachments ? JSON.parse(email.attachments) : [],
  }));
};
